import React from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '../../../Services/PermissionsContext'; // Import the permissions context
import { hasPermission } from '../../../Services/checkPermissions';   // Import the helper function

const TabMenu = ({ name }) => {
    const permissions = usePermissions(); // Get global permissions
    if (permissions.length === 0) {
        return <div>No permissions available</div>; // Handle case when there are no permissions
    }

    return (
        <div className='management-tabs'>
            <ul className='management-tablinks'>
               {hasPermission(permissions, 'pending-payout-report', 'view') && 
                    <li className={`action-item ${name === 'pending-payout-report' ? 'active-tab' : ''}`}>
                        <Link to="/admin/phlebotomist-payout-report/pending-payout-report">Phlebotomist Payout Report</Link>
                    </li>
                }
                {hasPermission(permissions, 'payout-history', 'view') && 
                <li className={`action-item ${name === 'payout-history' ? 'active-tab' : ''}`}>
                    <Link to="/admin/phlebotomist-payout-report/payout-history">Payout History</Link>
                </li>
                }

            </ul>
        </div>
    );
};

export default TabMenu;
